import Grid from '@mui/material/Grid';

const LinksHeader = () => {
  return (
    <Grid container className='page-header'>
      <Grid item size={{ xs: 12 }}>
        <Grid container direction={'row'}>
          <Grid item size={{ xs: 4 }} textAlign={'start'}>
            <h3>Links pendientes</h3>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default LinksHeader;
